import { render } from "./Dashboard.vue?vue&type=template&id=96381794&ts=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=96381794&lang=scss"
import "./Dashboard.vue?vue&type=style&index=1&id=96381794&lang=css"
import "./Dashboard.vue?vue&type=style&index=2&id=96381794&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__